import request from '@/router/axios'

const BASE = '/api/produce/power-room-monitor'

export const roomPage = (data) => request({ url: `${BASE}/room/selectPage`, method: 'post', data })
export const roomDetail = (id) => request({ url: `${BASE}/room/selectId`, method: 'get', params: { id } })
export const roomInsert = (data) => request({ url: `${BASE}/room/insert`, method: 'post', data })
export const roomUpdate = (data) => request({ url: `${BASE}/room/update`, method: 'post', data })
export const roomRemove = (id) => request({ url: `${BASE}/room/deleteId`, method: 'get', params: { id } })

export const channelPage = (data) => request({ url: `${BASE}/channel/selectPage`, method: 'post', data })
export const channelDetail = (id) => request({ url: `${BASE}/channel/selectId`, method: 'get', params: { id } })
export const channelInsert = (data) => request({ url: `${BASE}/channel/insert`, method: 'post', data })
export const channelUpdate = (data) => request({ url: `${BASE}/channel/update`, method: 'post', data })
export const channelRemove = (id) => request({ url: `${BASE}/channel/deleteId`, method: 'get', params: { id } })
export const channelStart = (id) => request({ url: `${BASE}/channel/start`, method: 'post', params: { id } })
export const channelStop = (id) => request({ url: `${BASE}/channel/stop`, method: 'post', params: { id } })
export const channelRestart = (id) => request({ url: `${BASE}/channel/restart`, method: 'post', params: { id } })
export const channelTestConnect = (id) => request({ url: `${BASE}/channel/test-connect`, method: 'post', params: { id } })
export const hikPemsSync = () => request({ url: `${BASE}/hik-pems/sync`, method: 'post' })

export const pointPage = (data) => request({ url: `${BASE}/point/selectPage`, method: 'post', data })
export const pointDetail = (id) => request({ url: `${BASE}/point/selectId`, method: 'get', params: { id } })
export const pointInsert = (data) => request({ url: `${BASE}/point/insert`, method: 'post', data })
export const pointUpdate = (data) => request({ url: `${BASE}/point/update`, method: 'post', data })
export const pointRemove = (id) => request({ url: `${BASE}/point/deleteId`, method: 'get', params: { id } })
